// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Svg from "../../primitives/Svg.res.js";
import * as Hover from "../../primitives/Hover.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as React from "react";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Offset from "../../resources/layout-and-structure/Offset.res.js";
import * as Tooltip from "../../resources/overlays/Tooltip.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as Touchable from "../../primitives/Touchable.res.js";
import * as CopyButton from "../../resources/actions/CopyButton.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Stylex from "@stylexjs/stylex";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
function LabelTableCell$CopyButton(props) {
  return JsxRuntime.jsx(Offset.make, {
    children: JsxRuntime.jsx(CopyButton.Compact.make, {
      value: props.value,
      spaceLeft: "xxsmall"
    }),
    top: -3,
    width: 13,
    height: 13
  });
}
let CopyButton$1 = {
  make: LabelTableCell$CopyButton
};
let styles = {
  root: {
    "pointerEvents-kfzvcC": "pointerEvents-x47corl",
    "transform-k3aq6I": "transform-x11lhmoz",
    "alignItems-kGNEyG": "alignItems-x6s0dn4",
    "display-k1xSpc": "display-x78zum5",
    "height-kZKoxP": "height-x1gnnpzl",
    "justifyContent-kjj79g": "justifyContent-xl56j7k",
    "position-kVAEAm": "position-x10l6tqk",
    "right-kCIrl2": "right-x1p4y56j",
    "top-k87sOh": "top-xwa60dl",
    "width-kzqmXN": "width-x1kl0l3y",
    $$css: "wino-gc:src/modules/TableCell/LabelTableCell.res.js:35"
  }
};
function styleProps(hovered) {
  return Stylex.props(styles.root, {
    backgroundColor: hovered ? "#f3f3f7" : "transparent",
    opacity: hovered ? 1 : 0,
    transition: "width .15s ease, opacity .15s ease, backgroundColor .05s ease, boxShadow .05s ease",
    boxShadow: (hovered ? "#f3f3f7" : "transparent") + ` -8px 0 13px 10px`,
    width: hovered ? "21px" : "0px"
  });
}
function LabelTableCell$PressableIconIndicator(props) {
  let match = styleProps(props.hovered);
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx(Svg.make, {
      children: JsxRuntime.jsx(Svg.Path.make, {
        d: "M 11.236 4.018 L 16.683 9.464 L 1.97 9.464 C 1.559 9.464 1.301 9.91 1.508 10.267 C 1.603 10.433 1.779 10.535 1.97 10.535 L 16.799 10.535 L 11.352 15.981 C 11.06 16.272 11.194 16.768 11.592 16.876 C 11.775 16.926 11.973 16.873 12.108 16.738 L 18.408 10.436 C 18.618 10.227 18.618 9.887 18.408 9.679 L 11.991 3.263 C 11.784 3.053 11.444 3.053 11.236 3.263 C 11.027 3.47 11.027 3.81 11.236 4.018 Z",
        fill: "#25243A"
      }),
      width: "14",
      height: "16",
      viewBox: "0 0 20 20"
    }),
    className: match.className,
    style: match.style
  });
}
let PressableIconIndicator = {
  styles: styles,
  styleProps: styleProps,
  make: LabelTableCell$PressableIconIndicator
};
let styles$1 = {
  wrapper: {
    "alignContent-kfiyM8": "alignContent-xc26acl",
    "height-kZKoxP": "height-x1gnnpzl",
    "width-kzqmXN": "width-xh8yej3",
    $$css: "wino-gc:src/modules/TableCell/LabelTableCell.res.js:85"
  }
};
let make = React.forwardRef((props, ref) => {
  let __textDirection = props.textDirection;
  let __inPrimaryColumn = props.inPrimaryColumn;
  let href = props.href;
  let tooltip = props.tooltip;
  let __showCopyButton = props.showCopyButton;
  let __align = props.align;
  let __maxLines = props.maxLines;
  let __sublabelItalic = props.sublabelItalic;
  let __sublabelBold = props.sublabelBold;
  let __sublabelEndElement = props.sublabelEndElement;
  let __sublabelStartElement = props.sublabelStartElement;
  let __sublabelVariation = props.sublabelVariation;
  let sublabel = props.sublabel;
  let __labelItalic = props.labelItalic;
  let __labelStrikethrough = props.labelStrikethrough;
  let __labelEndElement = props.labelEndElement;
  let labelStartElement = props.labelStartElement;
  let __labelBold = props.labelBold;
  let label = props.label;
  let labelBold = __labelBold !== undefined ? __labelBold : false;
  let labelEndElement = __labelEndElement !== undefined ? __labelEndElement : null;
  let labelStrikethrough = __labelStrikethrough !== undefined ? __labelStrikethrough : false;
  let labelItalic = __labelItalic !== undefined ? __labelItalic : false;
  let sublabelVariation = __sublabelVariation !== undefined ? __sublabelVariation : "normal";
  let sublabelStartElement = __sublabelStartElement !== undefined ? __sublabelStartElement : null;
  let sublabelEndElement = __sublabelEndElement !== undefined ? __sublabelEndElement : null;
  let sublabelBold = __sublabelBold !== undefined ? __sublabelBold : false;
  let sublabelItalic = __sublabelItalic !== undefined ? __sublabelItalic : false;
  let maxLines = __maxLines !== undefined ? __maxLines : 1;
  let align = __align !== undefined ? __align : "start";
  let showCopyButton = __showCopyButton !== undefined ? __showCopyButton : false;
  let inPrimaryColumn = __inPrimaryColumn !== undefined ? __inPrimaryColumn : false;
  let textDirection = __textDirection !== undefined ? __textDirection : "ltr";
  let ref$1 = ref == null ? undefined : Primitive_option.some(ref);
  let match = Hover.use(ref$1, undefined, undefined);
  let hovered = match[1];
  let labelWeight = labelBold || inPrimaryColumn ? "semibold" : "regular";
  let labelSize = !inPrimaryColumn && Stdlib_Option.isSome(sublabel) && labelBold ? "xxsmall" : "xsmall";
  let tmp;
  if (labelStartElement !== undefined) {
    let newrecord = {
      ...{
        style: {
          display: "flex",
          flex: "0 0 auto"
        }
      }
    };
    tmp = JsxRuntime.jsx("span", (newrecord.children = labelStartElement, newrecord));
  } else {
    tmp = null;
  }
  let content = JsxRuntime.jsxs(Inline.make, {
    children: [tmp, JsxRuntime.jsxs(Stack.make, {
      children: [JsxRuntime.jsxs(Inline.make, {
        children: [JsxRuntime.jsx(TextStyle.make, {
          children: label,
          variation: props.labelVariation,
          weight: labelWeight,
          size: labelSize,
          strikethrough: labelStrikethrough,
          italic: labelItalic,
          maxLines: maxLines,
          direction: textDirection
        }), labelEndElement, showCopyButton && hovered ? JsxRuntime.jsx(LabelTableCell$CopyButton, {
          value: label
        }) : null],
        align: align
      }), sublabel !== undefined ? JsxRuntime.jsxs(Inline.make, {
        children: [sublabelStartElement, JsxRuntime.jsx(TextStyle.make, {
          children: sublabel,
          variation: sublabelVariation,
          weight: sublabelBold ? "semibold" : "regular",
          size: "tiny",
          lineHeight: "normal",
          italic: sublabelItalic,
          maxLines: 1,
          direction: textDirection
        }), sublabelEndElement],
        align: align
      }) : null],
      space: "none"
    })],
    space: "xsmall",
    align: align,
    alignY: "top",
    fullWidth: true
  });
  let content$1 = tooltip !== undefined ? JsxRuntime.jsx(Tooltip.make, {
    children: content,
    arrowed: false,
    placement: "top start",
    content: tooltip,
    triggerCursor: Stdlib_Option.isSome(href) ? "pointer" : "help"
  }) : content;
  let content$2 = href !== undefined ? JsxRuntime.jsxs(Touchable.make, {
    children: [content$1, JsxRuntime.jsx(LabelTableCell$PressableIconIndicator, {
      hovered: hovered
    })],
    href: href,
    routerOptions: props.routerOptions
  }) : content$1;
  let newrecord$1 = {
    ...{
      className: "alignContent-xc26acl height-x1gnnpzl width-xh8yej3",
      "data-style-src": "wino-gc:src/modules/TableCell/LabelTableCell.res.js:85"
    }
  };
  return JsxRuntime.jsx("div", (newrecord$1.ref = Primitive_option.some(match[0]), newrecord$1.children = content$2, newrecord$1));
});
let make$1 = React.memo(make);
export { CopyButton$1 as CopyButton, PressableIconIndicator, styles$1 as styles, make$1 as make };
/* styles Not a pure module */